import { useEffect, useState, useMemo } from 'react';
import AllCourses from "../All Courses/AllCourses";
import './Categories.css';
import Category from '../../../Skill Development/SDComponents/Course Categories/Every Category/Category';
import Data from '../All Courses/AllCourseData';
import course from '../../../Dashboard/assets/courses.json'


const Categories = () =>{
  const [data,setData] = useState(course);
  const [selectedCategory , setCategory] = useState("All")

   const filteredCourses = useMemo(() => {
        if (selectedCategory === "All") return data;

        return data.filter(
            (course) => course.skillType === selectedCategory
        );
    }, [selectedCategory]);

    console.log("=>",filteredCourses);
    return(
       <>
        <div id="categories-header-section">
            <div id="categories-header-bg"></div>
            <div id="couse-categories-text">Skill Development</div>

            {/* all categories names */}
            <div id="all-categories-scroll-section">
                <div onClick={()=>setCategory("All")}  className="every-category ">All</div>
                <div onClick={()=>setCategory('Business Skill')}  className="every-category" >Business skill</div>
                <div onClick={()=>setCategory('Technology Skill')}  className="every-category" >Technology skill</div>
                <div onClick={()=>setCategory('Art Skill')}  className="every-category" >Art skill</div>
            </div>
        </div>
        <AllCourses CategoryName={filteredCourses}/>

        </>
    )
}

export default Categories;